import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { compose, branch, renderComponent } from 'recompose';
import * as PropTypes from 'prop-types';
import size from 'lodash/size';
import cn from 'classnames';

import MobleVideo from '../MobileVideo';
import AudioTag from '../Components/AudioTag';
import MemberList from '../Components/MemberList';
import ActiveSpeaker from '../Components/ActiveSpeaker';
import MembersSidebar from '../Components/MembersSidebar';
import { OTContext } from '../../../redux/opentok/context';
import VideoNotifications from '../Components/Notifications';
import { useDropVideo } from '../../../redux/opentok/hooks/useDragVideo';
import styles from './styles.styl';

function OpentokVideo({ collapsed, fullScreenView, toggleFullScreenView }) {
  const { state, isProvider, setPin, PUBLISHER_KEY, sendSignal } = useContext(
    OTContext,
  );
  const { connections, pinnedId, invitations } = state;
  const { coords, drop } = useDropVideo();
  const fullScreenRef = useRef();

  const { publisher, subscribers } = useMemo(() => {
    const { [PUBLISHER_KEY]: pub, ...sub } = connections;
    return { publisher: pub, subscribers: sub };
  }, [connections]);

  const selectActiveSpeaker = () => {};

  useEffect(() => {
    if (fullScreenRef.current) {
      if (fullScreenView) {
        sendSignal({ data: { fullScreenMode: true }, type: 'fullscreen' });
        if (fullScreenRef.current.requestFullscreen) {
          fullScreenRef.current.requestFullscreen();
        } else if (fullScreenRef.current.mozRequestFullScreen) {
          fullScreenRef.current.mozRequestFullScreen();
        } else if (fullScreenRef.current.webkitRequestFullScreen) {
          fullScreenRef.current.webkitRequestFullScreen();
        } else if (fullScreenRef.current.msRequestFullscreen) {
          fullScreenRef.current.msRequestFullscreen();
        }
      } else if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (document.mozFullscreenElement) {
        document.mozCancelFullScreen();
      } else if (document.webkitFullScreenElement) {
        document.webkitCancelFullScreen();
      } else if (document.msFullscreenElement) {
        document.msExitFullscreen();
      }
    }
  }, [fullScreenView]);

  return (
    <div
      ref={drop}
      className={styles.root}
      onDoubleClick={() => !collapsed && toggleFullScreenView()}
    >
      <div className={cn({ [styles.hidden]: collapsed || fullScreenView })}>
        <MembersSidebar count={size(connections) + size(invitations)}>
          <MemberList
            onPin={setPin}
            pinnedId={pinnedId}
            publisher={publisher}
            isProvider={isProvider}
            subscribers={subscribers}
            invitations={invitations}
            onSelect={selectActiveSpeaker}
          />
        </MembersSidebar>
      </div>
      <div className={styles.fullScreenContainer} ref={fullScreenRef}>
        {!collapsed && <VideoNotifications fullScreenView={fullScreenView} />}
        <ActiveSpeaker
          onPin={setPin}
          coords={coords}
          publisher={publisher}
          fullScreenView={fullScreenView}
        />
      </div>
      <AudioTag />
    </div>
  );
}

OpentokVideo.propTypes = {
  collapsed: PropTypes.bool,
  fullScreenView: PropTypes.bool,
  toggleFullScreenView: PropTypes.func,
};

const MOBILE_BREAKPOINT = 480;

const enhance = compose(
  branch(() => {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }, renderComponent(MobleVideo)),
);

export default enhance(OpentokVideo);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/OpentokVideo/index.jsx